import React from "react";
import {getWeeks, renderPrintFooter} from "../../utils";
import Input from "../Input";
import {executeQuery} from "../../requests/executeQuery";
import {manageData} from "../../requests/CRUD";
import {BucketsColumnsModel} from "./bucketsColumnsModel";
import {columns, averageColumns} from "./columns";
import {STRIVE_BUCKETS} from "../../consts/queries";
import {OVERFLOW_TABLE_WIDTH} from '../../consts/tables';
import {BUCKETS} from "../../consts/tables";
import './Buckets.scss';
import Alert from "../Alert";
import {Link} from "react-router";
import {stringUStoISO} from "../../date-converter";

const cloneDeep = require('lodash.clonedeep');
const tableHeaderHeight = 48;

export default class Buckets extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            rows: {},
            width: 1400,
            height: tableHeaderHeight,
            original: null,
            isBusy: null,
            error: null,
            success: null,
            isPrint: false,
            printBackground: '',
        };

        this.tableRef = React.createRef();

        this.handleChange = this.handleChange.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.updateTableWidth = this.updateTableWidth.bind(this);
        this.beforePrint = this.beforePrint.bind(this);
        this.afterPrint = this.afterPrint.bind(this);
    }

    componentDidMount() {
        this.updateTableWidth();
        this.setState({printBackground: `url('${arc.path.media+'Transaction_Background.png'}')`}, this.fetch);
        window.addEventListener('resize', this.updateTableWidth);
        window.onbeforeprint = this.beforePrint;
        window.onafterprint = this.afterPrint;
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateTableWidth);
    }

    beforePrint() {
        this.setState({isPrint: true});
    }

    afterPrint() {
        this.setState({isPrint: false});
    }

    static buildData(data, year) {
        const rows = {};
        data.map(row => {
            rows[row.AGENT_LAST_NAME] = new BucketsColumnsModel(row, year);
        });
        return rows;
    }

    fetch() {
        executeQuery({queryName: STRIVE_BUCKETS}).then(res => {
            if (res && res.success && Array.isArray(res.data) && res.data.length) {
                const year = new Date().getFullYear();
                const rows = Buckets.buildData(res.data, year);
                this.setState({rows, original: cloneDeep(rows)}, () => {
                    const headerHeight = 40;
                    const headDetailsHeight = this.props.isSuper ? 163 : 116;
                    const bottomSpaceHeight = 30;
                    let height = window.innerHeight - headerHeight - headDetailsHeight - bottomSpaceHeight;
                    if (height > this.tableRef.current.clientHeight && this.tableRef.current.clientHeight >= tableHeaderHeight) {
                        height = this.tableRef.current.clientHeight;
                    }
                    this.setState({height});
                });
            }
        });
    }

    handleChange(e, columnType) {
        const rows = cloneDeep(this.state.rows);
        const name = e.currentTarget.name.split('-');
        const rowKey = name[0];
        const colKey = name[1];
        if (columnType === 'date') {
            rows[rowKey][colKey] = e.currentTarget.value ? e.currentTarget.value.replace(/[^0-9/]/g, '') : '';
        } else {
            rows[rowKey][colKey] = e.currentTarget.value ? e.currentTarget.value.replace(/[^0-9.]/g, '') : '';
            rows[rowKey][`AVE_${colKey}`] = rows[rowKey][colKey] ? parseFloat(rows[rowKey][colKey] / rows[rowKey].WEEKS).toFixed(2) : 0;
        }
        this.setState({rows});
    }

    handleBlur(e, columnType) {
        const rows = cloneDeep(this.state.rows);
        const name = e.currentTarget.name.split('-');
        const rowKey = name[0];
        rows[rowKey].WEEKS = getWeeks(new Date(rows[rowKey].START_DATE), new Date());
        if (columnType === 'date')
            averageColumns.map(column => {
                const key = column.key.replace('AVE_', '');
                rows[rowKey][column.key] = rows[rowKey][key] ? parseFloat(rows[rowKey][key] / rows[rowKey].WEEKS).toFixed(2) : 0;
            });
        this.setState({rows});
    }

    handleSave() {
        if (this.state.isBusy) return;

        let rows = cloneDeep(this.state.rows);
        const columnsToSave = columns.filter(column => column.editable);
        const data = [];
        let index = 0;
        // Save only if updates exist
        Object.keys(rows).forEach(agent => {
            data[index] = {};
            columnsToSave.forEach(column => {
                if (column.type === 'date' && rows[agent][column.key])
                    rows[agent][column.key] = stringUStoISO(rows[agent][column.key]);
                if (rows[agent][column.key] !== this.state.original[agent][column.key])
                    data[index][column.key] = rows[agent][column.key];
            });

            if (Object.keys(data[index]).length)
                data[index++].AGENT_ID = rows[agent].AGENT_ID;
            else
                data.pop();
        });

        // No changes detected, nothing to do
        if (!data.length) {
            this.setState({
                isBusy: null,
                error: null,
                success: 'No data to update',
            });
            return;
        }

        this.setState({
            isBusy: true,
            error: null,
            success: null,
        });

        manageData({tableCode: BUCKETS, data}).then(res => {
            if (res && res.success) {
                this.setState({
                    isBusy: null,
                    success: 'Saved',
                    original: cloneDeep(rows),
                })
            } else {
                this.setState({
                    isBusy: null,
                    error: res && res.message ? res.message : 'Unspecified error',
                });
            }
        });
    }

    updateTableWidth() {
        this.setState({width: window.innerWidth - OVERFLOW_TABLE_WIDTH});
    }

    renderTable({rows, cols, isPrintTable}) {
        return (
            <table className='table' ref={!isPrintTable && this.tableRef}>
                <thead>
                <tr>
                    {
                        cols.map((column, index) => {
                            if (index === 0)
                                return <th key={index} className="Buckets_th border_top border_left" id='Buckets_first_cell'>{column.label}</th>;
                            return <th key={index} className="Buckets_th border_top">{column.label}</th>
                        })
                    }
                </tr>
                </thead>
                <tbody>
                {
                    Object.keys(rows).map(key => {
                        if (!rows[key]) return;
                        return (
                            <tr key={key} className="Buckets_tr">
                                {
                                    cols.map((column, index) => {
                                        if (index === 0)
                                            return (
                                                <th key={key+'-'+index} className='Buckets_th agents border_left'>
                                                    <Link to={{pathname: `${arc.path.base}buckets/${rows[key].AGENT_ID}`, state: {id: rows[key].AGENT_ID, name: rows[key].AGENT_FULL_NAME}}}>{key}</Link>
                                                </th>
                                            );
                                        if (this.props.isSuper && column.editable)
                                            return (
                                                <td key={key+'-'+index} className={`Buckets_td ${column.hasHighlight ? 'highlighted' : ''}`}>
                                                    <Input theme={column.hasHighlight ? 'gray_without_border' : 'without_border'} className='Buckets_td' type='text' pattern={column.type === 'number' ? '^[0-9]*$' : ''} name={key+'-'+column.key} value={rows[key][column.key]} displayZero={true} onChange={(e) => this.handleChange(e, column.type)} onBlur={(e) => this.handleBlur(e, column.type)}/>
                                                </td>
                                            );
                                        return (
                                            <td key={key+'-'+index} className={`Buckets_td ${column.hasHighlight ? 'highlighted' : ''}`}>
                                                {rows[key][column.key]}
                                            </td>
                                        );
                                    })
                                }
                            </tr>
                        );
                    })
                }
                </tbody>
            </table>
        );
    }

    renderPrintPage({rows, cols, date, isPrint, printBackground}) {
        return (
            <div className='print-container' style={{backgroundImage: isPrint && printBackground}}>
                <div className='Buckets_head_left'>
                    <h3 className='Buckets_h3'>STRIVE Buckets</h3>
                    <h4 className='Buckets_h4'>{date}</h4>
                </div>
                <div className='table-print-container'>
                    {this.renderTable({rows, cols, isPrintTable: true})}
                </div>
                {renderPrintFooter(isPrint)}
            </div>
        )
    }

    render() {
        const {rows, isPrint, printBackground} = this.state;
        const isSuper = this.props.isSuper;
        const d = new Date();
        const date = d.getMonth()+1+'/'+d.getDate()+'/'+d.getFullYear();

        return (
            <div className='Buckets'>
                { this.state.success ? <Alert type='success' position='absolute'>{this.state.success}</Alert> : null }
                { this.state.error ? <Alert type='error' position='absolute'>{this.state.error}</Alert> : null }

                {this.renderPrintPage({rows, cols: columns, date, isPrint, printBackground})}
                <div className='preload-print-background' style={{backgroundImage: printBackground}}/>

                <div className='Buckets_head'>
                    <h3 className='Buckets_h3'>STRIVE Buckets</h3>
                    <h4 className='Buckets_h4'>{date}</h4>
                    {isSuper ? <button className='Buckets_save' data-busy={this.state.isBusy} onClick={this.handleSave}>Save</button> : null }
                </div>
                <div className='Buckets_scroll_container' style={{width: this.state.width, height: this.state.height}}>
                    {this.renderTable({rows, cols: columns})}
                </div>
            </div>
        )
    }
}